module.exports = __webpack_public_path__ + "static/img/bg_line.00f89871.png";